export const apiScopes = [
  { id: 'read', label: 'Read', description: 'View members, balances, and rewards' },
  { id: 'earn', label: 'Earn', description: 'Award points to members' },
  { id: 'redeem', label: 'Redeem', description: 'Redeem rewards on behalf of members' },
];

export type ApiKey = {
  id: string;
  platform: string;
  keyHint: string;
  scopes: string[];
  status: 'active' | 'revoked';
  lastUsedAt: string;
  createdAt: string;
  callsThisMonth: number;
};

export const apiKeys: ApiKey[] = [
  {
    id: 'key-01',
    platform: 'BloomCommerce',
    keyHint: 'lb_live_4f2a••••••',
    scopes: ['read', 'earn', 'redeem'],
    status: 'active',
    lastUsedAt: '2 min ago',
    createdAt: 'Mar 12, 2025',
    callsThisMonth: 128402,
  },
  {
    id: 'key-02',
    platform: 'NovaMarket',
    keyHint: 'lb_live_9c71••••••',
    scopes: ['read', 'earn', 'redeem'],
    status: 'active',
    lastUsedAt: '14 min ago',
    createdAt: 'Feb 3, 2025',
    callsThisMonth: 94118,
  },
  {
    id: 'key-03',
    platform: 'Kartel',
    keyHint: 'lb_live_2d84••••••',
    scopes: ['read', 'earn', 'redeem'],
    status: 'active',
    lastUsedAt: '38 min ago',
    createdAt: 'Jan 21, 2025',
    callsThisMonth: 61375,
  },
  {
    id: 'key-04',
    platform: 'Loop',
    keyHint: 'lb_live_7e33••••••',
    scopes: ['read', 'earn'],
    status: 'active',
    lastUsedAt: '1 hr ago',
    createdAt: 'Dec 9, 2024',
    callsThisMonth: 42088,
  },
  {
    id: 'key-05',
    platform: 'Vantage',
    keyHint: 'lb_live_a5b9••••••',
    scopes: ['read', 'redeem'],
    status: 'active',
    lastUsedAt: '3 hr ago',
    createdAt: 'Nov 15, 2024',
    callsThisMonth: 28455,
  },
  {
    id: 'key-06',
    platform: 'Cedar',
    keyHint: 'lb_live_c0e1••••••',
    scopes: ['read'],
    status: 'revoked',
    lastUsedAt: '3 weeks ago',
    createdAt: 'Oct 2, 2024',
    callsThisMonth: 0,
  },
  {
    id: 'key-07',
    platform: 'Test environment',
    keyHint: 'lb_test_1f6d••••••',
    scopes: ['read', 'earn', 'redeem'],
    status: 'revoked',
    lastUsedAt: '2 months ago',
    createdAt: 'Sep 18, 2024',
    callsThisMonth: 0,
  },
];